var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaceholderImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "301px",
    height: "301px",
    viewBox: "0 0 301 301",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "placeholder-img") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App-|-Design-|-Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Design-/-Onboarding",
    transform: "translate(-449.000000, -252.000000)",
    fill: "#DEDEDE"
  }, /*#__PURE__*/React.createElement("g", {
    id: "placeholder-img",
    transform: "translate(450.000000, 253.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#DEDEDE",
    fillOpacity: 0.1,
    x: 0,
    y: 0,
    width: 299,
    height: 299
  }), /*#__PURE__*/React.createElement("g", {
    id: "img-icon",
    transform: "translate(122.000000, 131.000000)",
    stroke: "#ADADAD"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-16",
    points: "0 36.5812397 13.4411418 19.5828203 27.6686357 26.0816644 39.1209107 8.12916438 55.3372713 36.5812397"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 51.2382142,
    cy: 4.06458219,
    rx: 4.09905713,
    ry: 4.06458219
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderImg);
export default __webpack_public_path__ + "static/media/placeholder-img.b7d04210ad1d54aad71538c92c64796e.svg";
export { ForwardRef as ReactComponent };